const nav = document.getElementById('navigation');
const burger = document.querySelector('.site-nav-burger');
const backdrop = document.querySelector('.site-nav-backdrop');
const closeButton = nav?.querySelector('.site-nav-close');

const setOpen = (open) => {
	document.body.classList.toggle('is-nav-open', open);
	burger?.setAttribute('aria-expanded', String(open));
};

burger?.addEventListener('click', () => setOpen(true));
closeButton?.addEventListener('click', () => setOpen(false));
backdrop?.addEventListener('click', () => setOpen(false));
nav?.querySelectorAll('.nav-link').forEach((link) => {
	link.addEventListener('click', () => setOpen(false));
});
document.addEventListener('keydown', (event) => {
	if (event.key == 'Escape') {
		setOpen(false);
	}
});
